"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FileUploadListDefault = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FileNameLabel = require("../FileNameLabel");
var _formatters = require("../../../../../helpers/formatters");
var _formFieldPropTypes = require("../../../../../propTypes/formFieldPropTypes");
var _FileValidation = require("../FileValidation");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const FileUploadListDefault = _ref => {
  let {
    fileList,
    validFiles,
    onFileRemove
  } = _ref;
  const filesArray = Array.from(fileList);
  if (filesArray.length === 0) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "selectedFiles"
  }, /*#__PURE__*/_react.default.createElement("h3", null, "Selected files"), /*#__PURE__*/_react.default.createElement("ul", null, filesArray.map(file => /*#__PURE__*/_react.default.createElement("li", {
    key: file.name,
    className: (0, _FileValidation.CheckFileSize)({
      file,
      maxFileSize: validFiles.maxFileSize
    }) ? 'error' : ''
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "fileName"
  }, /*#__PURE__*/_react.default.createElement(_FileNameLabel.FileNameLabel, {
    onFileRemove: onFileRemove,
    file: file,
    validFiles: validFiles
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "fileSize"
  }, (0, _formatters.FormatFileSize)(file.size)))))));
};
exports.FileUploadListDefault = FileUploadListDefault;
FileUploadListDefault.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  fileList: _propTypes.default.any,
  validFiles: _formFieldPropTypes.ValidFilesPropTypes,
  onFileRemove: _propTypes.default.func
};